import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import { Typography } from "@mui/material";
import CloseButton from "react-bootstrap/CloseButton";

const ChipsStyled = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  padding: "8px",
  borderRadius: "4px",
  cursor: "pointer",
  "& .btn-close": {
    border: "none",
    width: "8px",
    height: "8px",
    cursor: "pointer",
    marginLeft: "6px",
    color: colors.custom
  },
}));

export const Chips = ({
  index = -1,
  label = "",
  onClose = null,
  disabled = false,
}) => (
  <ChipsStyled
    style={{
      backgroundColor: disabled ? colors.disabled : colors.chipsBg,
    }}
  >
    <Typography
      variant="h4"
      sx={{ color: disabled ? colors.nonActive : colors.primary }}
    >
      {label}
    </Typography>
    {onClose && (
      <CloseButton
        bsPrefix="close-chips"
        onClick={() => onClose(label, index)}
      />
    )}
  </ChipsStyled>
);

Chips.propTypes = {
  index: PropTypes.number,
  label: PropTypes.string,
  onClose: PropTypes.func,
  disabled: PropTypes.bool,
};